const prefix = "";

export function saveSettings(key, data) {
    localStorage.setItem(prefix + key, JSON.stringify(data));
}

export function loadSettings(key) {
    const data = localStorage.getItem(prefix + key);
    if (data) {
        return JSON.parse(data);
    }
    return null;
}

export function removeSettings(key) {
    localStorage.removeItem(prefix + key);
}

export function animationFrame(fn) {
    const raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || ((fn) => { return window.setTimeout(fn, 20); });
    return raf(fn);
}

function requestFullscreenFns(elem) {
    return {
        request: elem.requestFullscreen || elem.webkitRequestFullScreen || elem.mozRequestFullScreen || elem.msRequestFullscreen,
        is: (document.fullScreenElement && document.fullScreenElement !== null) || document.mozFullScreen || document.webkitIsFullScreen,
        exit: document.exitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen
    };
}

export function fullscreenSupported(elem) {
    const fns = requestFullscreenFns(elem);
    return !!fns.exit && !!fns.request;
}

export function fullscreenToggle(elem) {
    const fns = requestFullscreenFns(elem);
    if (fns.is) fns.exit.call(document); else fns.request.call(elem);
}

export function fullscreenEnable(elem) {
    const fns = requestFullscreenFns(elem);
    if (!fns.is) fns.request.call(elem);
}

export function clipboardCopy(data) {
    try {
        // copy as text
        const temp = document.createElement("input");
        temp.type = "text";
        temp.value = data;
        document.body.appendChild(temp);
        temp.select();
        document.execCommand("copy");
        document.body.removeChild(temp);
    } catch (err) {
        return err;
    }
    return null;
}

export function downloadFile(fileName, contentType, content) {
    const blob = new Blob([content], { type: contentType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link); // Required for FF
    link.click();
    document.body.removeChild(link);
}

export function formatFileSize(bytes, decimals) {
    if (bytes === 0 || bytes === undefined) return "";
    if (isNaN(parseFloat(bytes)) && !isFinite(bytes)) return "Not an number";
    const k = 1024;
    const dm = decimals != null && !isNaN(decimals) && decimals >= 0 ? decimals : 2;
    const sizes = ["B", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
